import React from 'react';
import './pactometroBarras.scss';
import { PropTypes } from 'prop-types';

export const PactometroBarras = ({
  data,
  totalSeat,
  selecteds,
  type = 'GENERAL'
}) => {
  const selectedData = data.filter(item =>
    selecteds.some(select => select === item.id)
  );

  const { seat, percent } = selectedData.reduce(
    (ac, current) => {
      return {
        seat: ac.seat + current.seats,
        percent: ac.percent + (current.votesPercent || 0)
      };
    },
    { seat: 0, percent: 0 }
  );
  return (
    <div className="pactos-barras">
      <div className="bloque-gris-pactometro">
        <p className="total-pactometro">
          Total{' '}
          {type === 'REGIONAL' || type === 'GENERAL'
            ? ' escaños'
            : ' concejales'}
          : <span id="">{seat}</span>
        </p>
        <div className="mayoria-pactometro-barras">
          <p>Mayoría absoluta: ({parseInt(totalSeat / 2, 10) + 1})</p>
        </div>
        <div id="barra" className="porcentaje-pactometro">
          {selectedData.map(element => (
            <div
              className="partido"
              key={`${element.partyAcronym}-${element.ineId}`}
              title={element.partyAcronym}
              style={{
                width: `${(100 / totalSeat) * element.seats}%`,
                backgroundColor: element.partyColor
              }}
            />
          ))}
        </div>
      </div>
      <div className="bloque-gris-pactometro">
        <p className="total-pactometro">
          Total Votos:{' '}
          <span id="">{`${parseFloat(percent).toFixed(2)} %`}</span>
        </p>
        <div className="mayoria-pactometro-barras">
          <p>50% </p>
        </div>
        <div id="barra" className="porcentaje-pactometro">
          {selectedData.map(element => (
            <div
              className="partido"
              title={element.name}
              style={{
                width: `${element.votesPercent}%`,
                backgroundColor: element.partyColor
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

PactometroBarras.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired
    })
  ).isRequired,
  selecteds: PropTypes.arrayOf(PropTypes.string).isRequired,
  totalSeat: PropTypes.number.isRequired
};

export default PactometroBarras;
